var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.bin
    ? _c("div", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventory.bin.name")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.bin.name,
                  expression: "bin.name"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.bin.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.bin, "name", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventory.bin.ident")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.bin.ident,
                  expression: "bin.ident"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.bin.ident },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.bin, "ident", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventory.bin.created")))]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.formatDateTime(_vm.bin.createdAt)))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventory.bin.updated")))]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.formatDateTime(_vm.bin.updatedAt)))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c("small", [
              _vm._v(_vm._s(_vm.$t("inventory.bin.locationAisle")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.bin.locationAisle,
                  expression: "bin.locationAisle"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.bin.locationAisle },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.bin, "locationAisle", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventory.bin.locationRow")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.bin.locationRow,
                  expression: "bin.locationRow"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.bin.locationRow },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.bin, "locationRow", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventory.bin.locationPin")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.bin.locationPin,
                  expression: "bin.locationPin"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.bin.locationPin },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.bin, "locationPin", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("small", [_vm._v(_vm._s(_vm.$t("inventory.bin.gtin")))]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.bin.gtin,
                  expression: "bin.gtin"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.bin.gtin },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.bin, "gtin", $event.target.value)
                }
              }
            })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }